import React from 'react'
import { ApplicationsGridCell } from '../../../../components/applications-grid-cell'
import { LibraryMergedApplication } from '../../helpers/ui-interfaces'
import {
  ApplicationLinkWithTooltip,
  SkeletorApplicationLinkWithTooltip
} from '../../../../components/application-tooltip'

export function LibraryMergedApplicationsCell({
  rowData: { organizationID, libraryName, mergedApplications }
}: {
  rowData: {
    organizationID: string
    libraryName: string
    mergedApplications: LibraryMergedApplication[]
  }
}) {
  return (
    <div data-testid="merged-applications-cell">
      <ApplicationsGridCell<LibraryMergedApplication>
        applications={mergedApplications}
        applicationContext={{ name: libraryName, type: 'library' }}
        renderApplication={({
          appId: applicationID,
          name: applicationName
        }) => (
          <ApplicationLinkWithTooltip
            showAttackStatus={false}
            applicationID={applicationID}
            applicationName={applicationName}
            organizationID={organizationID}
          />
        )}
        renderSkeletorApplication={({
          appId: applicationID,
          name: applicationName
        }) => (
          <SkeletorApplicationLinkWithTooltip
            showAttackStatus={false}
            applicationUuid={applicationID}
            applicationName={applicationName}
            organizationUuid={organizationID}
          />
        )}
      />
    </div>
  )
}
